import React, {createContext, useContext} from 'react';
import PropTypes from "prop-types";
import {PRICE_TYPE_GROSS, PRICE_TYPE_NET} from "../utils/price";

const ShowPriceContext = createContext(null);

export const ShowPriceProvider = ({ showPrice, children }) => {
  const [showPriceValue, setShowPriceValue] = React.useState(showPrice)

  return (
    <ShowPriceContext.Provider value={{
      showPrice: showPriceValue,
      setShowPrice: setShowPriceValue,
    }}>
      {children}
    </ShowPriceContext.Provider>
  );
};

ShowPriceProvider.propTypes = {
  showPrice: PropTypes.oneOf([PRICE_TYPE_NET, PRICE_TYPE_GROSS]).isRequired,
};

export const useShowPrice = () => {
  return useContext(ShowPriceContext);
};